<app-header></app-header>

<div class="container-fluid" style="width: 80%;">

    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a href="/home">Home</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item active" aria-current="page">Cruscotto richieste</li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Cruscotto richieste</h4>
        </div>
    </div>




    <mat-card class="p-2" appearance="outlined">

        <mat-card-header>
            <mat-card-title>Filtri di ricerca</mat-card-title>
        </mat-card-header>
        <form [formGroup]="formRicerca" (ngSubmit)="onSubmit()">
            <mat-card-content>

                <div class="row d-flex mt-4">

                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>S.I. Inviante</mat-label>
                            <mat-select formControlName="inviante" multiple>
                                @for (inviante of invianti; track inviante) {
                                <mat-option [value]="inviante.codice">{{inviante.descrizione}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Data arrivo da</mat-label>
                            <input matInput [matDatepicker]="pickerDa" formControlName="dataArrivoDa">
                            <mat-datepicker-toggle matIconSuffix [for]="pickerDa"></mat-datepicker-toggle>
                            <mat-datepicker #pickerDa></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Data arrivo a</mat-label>
                            <input matInput [matDatepicker]="pickerA" formControlName="dataArrivoA">
                            <mat-datepicker-toggle matIconSuffix [for]="pickerA"></mat-datepicker-toggle>
                            <mat-datepicker #pickerA></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Segnalazione</mat-label>
                            <mat-select formControlName="segnalazione" multiple>
                                @for (segnalazione of segnalazioni; track segnalazione) {
                                <mat-option [value]="segnalazione.id">{{segnalazione.descrizione}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Stato</mat-label>
                            <mat-select formControlName="stato">
                                <mat-option>Nessuna selezione</mat-option>
                                @for (stato of stati; track stato) {
                                <mat-option [value]="stato.id">{{stato.descrizione}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Centrale</mat-label>
                            <mat-select formControlName="centrale" multiple>
                                @for (centrale of centraliCOT; track centrale) {
                                <mat-option [value]="centrale.id">{{centrale.denominazione}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                </div>

                <div class="row d-flex">

                    <mat-form-field appearance="outline">
                        <mat-label>Cognome, nome o codice fiscale</mat-label>
                        <input matInput placeholder="Cognome, nome o codice fiscale" value="" formControlName="ricerca">
                        <mat-icon matSuffix>person</mat-icon>
                    </mat-form-field>

                </div>

            </mat-card-content>

            <mat-card-actions align="start">
                <button mat-flat-button>
                    <mat-icon>search</mat-icon>Cerca
                </button>

                <div style="margin-left: 0.2rem;"></div>

                <!-- 
                    <button mat-button (click)="nuovaRichiesta()" mat-button>
                        <mat-icon>add</mat-icon>Nuova richiesta
                    </button>
                -->

                <div style="margin-left: 0.2rem;"></div>
                <button mat-button (click)="pulisciForm()" mat-button>
                    <mat-icon>clear</mat-icon>Pulisci&nbsp;form
                </button>

                <div style="margin-left: 0.2rem;"></div>
                <button (click)="exportExcel()" disabled mat-button>
                    <mat-icon>downloading</mat-icon>Export foglio di calcolo
                </button>
            </mat-card-actions>

        </form>




    </mat-card>

    <div class="alert alert-primary mt-4 mb-4" role="alert">
        Richieste trovate: <b>{{pageElements}}</b>. Di cui <b>{{richiesteInLavorazione}}</b> in lavorazione.
    </div>



    <mat-card class="p-2" appearance="outlined">

        <mat-card-header>
            <mat-card-title>Risultati</mat-card-title>
        </mat-card-header>

        <div *ngIf="loading" class="loading-overlay d-flex justify-content-center align-items-center">
            <div class="progress-spinner progress-spinner-active"></div>
        </div>


        <div class="table-container" *ngIf="!loading">


            <table mat-table matSort [dataSource]="richieste" multiTemplateDataRows>

                <ng-container matColumnDef="apri">

                    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let sel">

                        <button mat-button (click)="apriRichiesta(sel.id)">
                            <span>Apri</span>
                        </button>

                    </td>

                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.id}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="cognome">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Cognome</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.assistito.cognome}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.assistito.nome}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="codiceFiscale">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Codice Fiscale</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.assistito.codiceFiscale}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="stato">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Stato</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.stato}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="segnalazione">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Segnalazione</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.segnalazione}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="settingProposto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Setting Proposto</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.settingProposto}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="settingDefinitivo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Setting Definitivo</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.settingDefinitivo}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="dataArrivo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Data arrivo</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel?.dataDimissionePrevista | date:'dd/MM/yyyy'}}
                    </td>
                </ng-container>


                <ng-container matColumnDef="siInviate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>S.I. Inviante</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.siInviante}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="struttureInviate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Struttura Inviante</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.strutturaInviante}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="centraleCOT">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Centrale COT</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.centraleCOT}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="strutturaRicevente">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Struttura Ricevente</th>
                    <td mat-cell *matCellDef="let sel">
                        {{sel.strutturaRicevente}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="alert">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Alert</th>
                    <td mat-cell *matCellDef="let sel">
                        <span *ngIf="sel.alert === 'Urgente'" class="badge rounded-pill bg-danger">
                            {{sel.alert}}
                        </span>
                        <span *ngIf="sel.alert !== 'Urgente'" class="badge rounded-pill bg-secondary">
                            {{sel.alert}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="operatore">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Operatori coinvolti</th>
                    <td mat-cell *matCellDef="let sel">
                        <button mat-button color="primary" (click)="openOperatoriCoinvolti(sel)">
                            Operatori coinvolti
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let sel">

                        <button [matMenuTriggerFor]="menu" class="btn btn-dropdown dropdown-toggle" type="button"
                            id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #menu="matMenu">
                            <button mat-menu-item disabled>Telefono <mat-icon>phone</mat-icon></button>
                            <button mat-menu-item (click)="archiviaRichiesta(sel)">Archivia
                                <mat-icon>archive</mat-icon></button>
                            <button mat-menu-item disabled>Trasferisci ad altra COT
                                <mat-icon>move_up</mat-icon></button>
                            <button mat-menu-item disabled>Assegna a operatore COT
                                <mat-icon>assignment_ind</mat-icon></button>
                        </mat-menu>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row " *matNoDataRow>
                    <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                        Nessun risultato.
                    </td>
                </tr>

            </table>

            <mat-paginator [pageIndex]="pageIndex" [length]="pageElements" [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]" (page)="handlePageEvent($event)" showFirstLastButtons
                aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>

    </mat-card>

</div>

<app-footer></app-footer>